export const TIMEZONE = 'Europe/Dublin';